import WidgetMobileUse from "./widget-mobile-use";

export default WidgetMobileUse;